"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextOverflow = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var Tooltip_1 = require("../Tooltip/Tooltip");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var textOverflowStyles = function (maxWidth) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  max-width: ", ";\n  white-space: nowrap;\n"], ["\n  display: block;\n  max-width: ", ";\n  white-space: nowrap;\n"])), maxWidth ? (0, design_system_foundations_1.mapCssValue)(maxWidth) : '100%'); };
var textOverflowWrapperStyles = function (color, font) {
    var resolvedColor = color ? (0, design_system_foundations_1.getPrefixedThemeColor)(color) : 'inherit';
    return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n  "], ["\n    ", ";\n    color: ", ";\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n  "])), font && (0, design_system_foundations_1.expandFontTheme)(font), resolvedColor);
};
var textOverflowTextStyles = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: unset;\n"], ["\n  display: unset;\n"])));
exports.TextOverflow = (0, react_1.forwardRef)(function (_a, ref) {
    var as = _a.as, color = _a.color, font = _a.font, _b = _a.hasArrow, hasArrow = _b === void 0 ? false : _b, _c = _a.placement, placement = _c === void 0 ? 'top-start' : _c, _d = _a.offset, offset = _d === void 0 ? [-6, 0] : _d, maxWidth = _a.maxWidth, testId = _a.testId, children = _a.children, rest = __rest(_a, ["as", "color", "font", "hasArrow", "placement", "offset", "maxWidth", "testId", "children"]);
    var testIdBase = "".concat(testId !== null && testId !== void 0 ? testId : 'textoverflow');
    var _e = (0, react_1.useState)(false), isOverflowing = _e[0], setIsOverflowing = _e[1];
    var itemRef = (0, react_1.useRef)(null);
    var wrapperRef = (0, react_1.useRef)(null);
    var checkOverflow = (0, react_1.useCallback)(function () {
        var _a, _b;
        if (wrapperRef.current && itemRef.current) {
            var wrapperWidth = (_a = wrapperRef.current.getBoundingClientRect().width) !== null && _a !== void 0 ? _a : 0;
            var textWidth = (_b = itemRef.current.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
            setIsOverflowing(textWidth > wrapperWidth);
        }
    }, [wrapperRef, itemRef]);
    (0, react_1.useLayoutEffect)(function () {
        checkOverflow();
    }, [checkOverflow, children]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', checkOverflow);
        return function () {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [checkOverflow]);
    return (react_1.default.createElement("span", __assign({ ref: ref, "data-testid": testIdBase }, rest, { className: (0, css_1.cx)('ds-textoverflow', textOverflowStyles(maxWidth), rest === null || rest === void 0 ? void 0 : rest.className) }),
        react_1.default.createElement("span", { ref: wrapperRef, className: textOverflowWrapperStyles(color, font), "data-testid": "".concat(testIdBase, "-wrapper") },
            react_1.default.createElement("span", { ref: itemRef, "data-testid": "".concat(testIdBase, "-inner-wrapper") }, isOverflowing ? (react_1.default.createElement(Tooltip_1.Tooltip, { placement: placement, hasArrow: hasArrow, offset: offset, body: children, testId: "".concat(testIdBase, "-tooltip") },
                react_1.default.createElement(design_system_typography_1.Text, { className: textOverflowTextStyles, as: as, font: font, color: color, testId: "".concat(testIdBase, "-overflowing-text") }, children))) : (react_1.default.createElement(design_system_typography_1.Text, { className: textOverflowTextStyles, as: as, font: font, color: color, testId: "".concat(testIdBase, "-text") }, children))))));
});
exports.TextOverflow.displayName = 'TextOverflow';
var templateObject_1, templateObject_2, templateObject_3;
